var _defs, _sodipodiNamedview, _metadata;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgW3CssIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    id: "svg3476",
    inkscapeVersion: "0.92.4 (5da689c313, 2019-01-14)",
    sodipodiDocname: "w3_css-icon.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3478"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    inkscapeZoom: 4.8766667,
    inkscapeCx: 27.142857,
    inkscapeCy: 28.571429,
    "inkscapeDocument-units": "px",
    "inkscapeCurrent-layer": "layer1",
    showgrid: "false",
    "fit-margin-top": 0,
    "fit-margin-left": 0,
    "fit-margin-right": 0,
    "fit-margin-bottom": 0,
    "inkscapeWindow-width": 1850,
    "inkscapeWindow-height": 1016,
    "inkscapeWindow-x": 70,
    "inkscapeWindow-y": 27,
    "inkscapeWindow-maximized": 1,
    units: "px"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata3481"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Calque 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    transform: "translate(-193.633,-739.48031)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#264de4"
    },
    points: "437.367,100.62 404.321,470.819 255.778,512 107.644,470.877 74.633,100.62 ",
    id: "polygon2989",
    transform: "matrix(0.15557406,0,0,0.15557392,185.82204,723.82646)"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2965f1"
    },
    points: "256,480.523 376.03,447.246 404.27,130.894 256,130.894 ",
    id: "polygon2991",
    transform: "matrix(0.15557406,0,0,0.15557392,185.82204,723.82646)"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ebebeb"
    },
    points: "256,268.217 150.31,268.217 154.38,313.627 256,313.627 ",
    id: "polygon2993",
    transform: "matrix(0.15557406,0,0,0.15557392,185.82204,723.82646)"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ebebeb"
    },
    points: "256,176.305 255.843,176.305 142.132,176.305 146.26,221.716 256,221.716 ",
    id: "polygon2995",
    transform: "matrix(0.15557406,0,0,0.15557392,185.82204,723.82646)"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ebebeb"
    },
    points: "156.409,336.333 162.771,407.634 255.791,433.457 256,433.399 256,386.153 255.801,386.206 205.227,372.55 201.994,336.333 177.419,336.333 ",
    id: "polygon2997",
    transform: "matrix(0.15557406,0,0,0.15557392,185.82204,723.82646)"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffffff"
    },
    points: "311.761,313.627 306.49,372.521 255.843,386.191 255.843,433.435 348.937,407.634 349.62,399.962 360.291,280.411 361.399,268.217 369.597,176.305 255.843,176.305 255.843,221.716 319.831,221.716 315.699,268.217 255.843,268.217 255.843,313.627 ",
    id: "polygon3005",
    transform: "matrix(0.15557406,0,0,0.15557392,185.82204,723.82646)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgW3CssIcon);
export default __webpack_public_path__ + "static/media/w3_css-icon.42d9cdf11e7c1264133555b8afda11e8.svg";
export { ForwardRef as ReactComponent };